import { TaskSystem } from "@/Features";

export const TasksPage = () => {
  return <TaskSystem />;
};
